import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=2aa7643c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa7643c')) {
      api.createRecord('2aa7643c', component.options)
    } else {
      api.reload('2aa7643c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=2aa7643c&", function () {
      api.rerender('2aa7643c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PVv6PT5ZrRrJ/JS/offershelp.vue"
export default component.exports